import { VariantType } from '../babylonjs/type/backendType'
import { ITexture } from '../babylonjs/type/modelType'

const woodTextureAssets: ITexture[] = [
  {
    id: 'wood-1',
    title: 'WOOD 1',
    source: {
      texture:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/Wood052_1K-JPG/Wood052_1K_Color.jpg',
      normal:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/Wood052_1K-JPG/Wood052_1K_Normal.jpg',
    },
    repeat: 1,
    roughness: 0.15,
    metallic: 0.3,
  },
  {
    id: 'wood-2',
    title: 'WOOD 2',
    source: {
      texture:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/Wood026_1K-JPG/Wood026_1K_Color.jpg',
      normal:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/Wood026_1K-JPG/Wood026_1K_Normal.jpg',
    },
    repeat: 1,
    roughness: 0.15,
    metallic: 0.3,
  },
  {
    id: 'wood-3',
    title: 'WOOD 3',
    source: {
      texture:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/Wood019_1K-JPG/Wood019_1K_Color.jpg',
      normal:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/Wood019_1K-JPG/Wood019_1K_Normal.jpg',
    },
    repeat: 1,
    roughness: 0.15,
    metallic: 0.3,
  },
  {
    id: 'wood-4',
    title: 'WOOD 4',
    source: {
      texture:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/Wood023_1K-JPG/Wood023_1K_Color.jpg',
      normal:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/Wood023_1K-JPG/Wood023_1K_Normal.jpg',
    },
    repeat: 1,
    roughness: 0.15,
    metallic: 0.3,
  },
].map(t => ({ ...t, variantType: VariantType.MATERIAL }))

const stoneTextureAssets: ITexture[] = [
  {
    id: 'maple-2',
    title: 'MARPLE 2',
    source: {
      texture:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/Marble014_1K-JPG/Marble014_1K_Color.jpg',
      normal:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/Marble014_1K-JPG/Marble014_1K_Normal.jpg',
    },
    repeat: 1,
    roughness: 0.1,
    metallic: 0.25,
  },
  {
    id: 'maple-3',
    title: 'MARPLE 3',
    source: {
      texture:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/Marble010_1K-JPG/Marble010_1K_Color.jpg',
      normal:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/Marble010_1K-JPG/Marble010_1K_Normal.jpg',
    },
    repeat: 1,
    roughness: 0.1,
    metallic: 0.25,
  },
  {
    id: 'maple-4',
    title: 'MARPLE 4',
    source: {
      texture:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/Marble008_1K-JPG/Marble008_1K_Color.jpg',
      normal:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/Marble008_1K-JPG/Marble008_1K_Normal.jpg',
    },
    repeat: 1,
    roughness: 0.1,
    metallic: 0.25,
  },
  {
    id: 'maple-5',
    title: 'MARPLE 5',
    source: {
      texture:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/Marble013_1K-JPG/Marble013_1K_Color.jpg',
      normal:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/Marble013_1K-JPG/Marble013_1K_Normal.jpg',
    },
    repeat: 1,
    roughness: 0.1,
    metallic: 0.25,
  },
].map(t => ({ ...t, variantType: VariantType.MATERIAL }))

export const fabricTextureAssets: ITexture[] = [
  {
    id: 'fabric-1',
    title: 'FABRIC 1',
    source: {
      texture:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/Fabric019_1K-JPG/Fabric019_1K_Color.jpg',
      normal:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/Fabric019_1K-JPG/Fabric019_1K_Normal.jpg',
    },
    repeat: 15,
    roughness: 0.2,
    metallic: 0.6,
  },
  {
    id: 'fabric-2',
    title: 'FABRIC 2',
    source: {
      texture:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/Fabric034_1K-JPG/Fabric034_1K_Color.jpg',
      normal:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/Fabric034_1K-JPG/Fabric034_1K_Normal.jpg',
    },
    repeat: 15,
    roughness: 0.2,
    metallic: 0.6,
  },
  {
    id: 'leather-1',
    title: 'LEATHER 1',
    source: {
      texture:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/Leather007_1K-JPG/Leather007_1K_Color.jpg',
      normal:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/Leather007_1K-JPG/Leather007_1K_Normal.jpg',
    },
    repeat: 20,
    roughness: 0.2,
    metallic: 0.6,
  },
  {
    id: 'leather-2',
    title: 'LEATHER 2',
    source: {
      texture:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/Leather001_1K-JPG/Leather001_1K_Color.jpg',
      normal:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/Leather001_1K-JPG/Leather001_1K_Normal.jpg',
    },
    repeat: 20,
    roughness: 0.2,
    metallic: 0.6,
  },
  {
    id: 'leather-3',
    title: 'LEATHER 3',
    source: {
      texture:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/Leather023_1K-JPG/Leather023_1K_Color.jpg',
      normal:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/Leather023_1K-JPG/Leather023_1K_Normal.jpg',
    },
    repeat: 20,
    roughness: 0.2,
    metallic: 0.6,
  },
].map(t => ({ ...t, variantType: VariantType.MATERIAL }))

const otherTextureAssets: ITexture[] = [
  {
    id: 'other-1',
    title: 'OTHER 1',
    source: {
      texture:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/Terrazzo008_1K-JPG/Terrazzo008_1K_Color.jpg',
      normal:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/Terrazzo008_1K-JPG/Terrazzo008_1K_Normal.jpg',
    },
    repeat: 5,
    roughness: 0.1,
    metallic: 0.25,
  },
  {
    id: 'other-2',
    title: 'OTHER 2',
    source: {
      texture:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/Rust005_1K-JPG/Rust005_1K_Color.jpg',
      normal:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/Rust005_1K-JPG/Rust005_1K_Normal.jpg',
    },
    repeat: 2,
    roughness: 0.3,
    metallic: 1,
  },
  {
    id: 'other-3',
    title: 'OTHER 3',
    source: {
      texture:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/Scratches005_1K-JPG/Scratches005_1K_var1.jpg',
      normal:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/Scratches005_1K-JPG/Scratches005_1K_Normal.jpg',
    },
    repeat: 3,
    roughness: 0.15,
    metallic: 0.3,
  },
  {
    id: 'other-4',
    title: 'OTHER 4',
    source: {
      texture:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/WoodChips002_1K-JPG/WoodChips002_1K_Color.jpg',
      normal:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/WoodChips002_1K-JPG/WoodChips002_1K_Normal.jpg',
    },
    repeat: 5,
    roughness: 0.15,
    metallic: 0.3,
  },
  {
    id: 'other-5',
    title: 'OTHER 5',
    source: {
      texture:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/DiamondPlate001_1K-JPG/DiamondPlate001_1K_Color.jpg',
      normal:
        'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/texture/DiamondPlate001_1K-JPG/DiamondPlate001_1K_Normal.jpg',
    },
    repeat: 8,
    roughness: 0.1,
    metallic: 1,
  },
].map(t => ({ ...t, variantType: VariantType.MATERIAL }))

export const textures: ITexture[] = woodTextureAssets.concat(
  stoneTextureAssets,
  fabricTextureAssets,
  otherTextureAssets
)
